export function computeZIndex(element: HTMLElement | null) {
    while (element) {
        if (element.style.zIndex && element.style.zIndex !== 'auto') {
            return parseInt(element.style.zIndex);
        }
        element = element.parentElement;
    }
}
